import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import { styleMethods } from 'dataviz/config/map';
import ZoneCollectionLayer from './ZoneCollectionLayer';
const baseString = 'vra-trial-placement-layer';
const classString = classNames({
  [`${baseString}`]: true
});

const TrialPlacementLayer = ({
  map,
  script
}) => {

  const zonesTypesById = {
    champion: script.zones.champion.id,
    challenger: script.zones.challenger.id
  };

  return script ? (
    <section className={classString}>
      <ZoneCollectionLayer
        layerName={`rx-${script.id}`} // help out with diffing
        map={map}
        onClickZone={()=>{}}
        styleFunction={styleMethods.trialPlacements(zonesTypesById)}
        zones={script.zones}
      />
    </section>
  ) : null;
};

TrialPlacementLayer.propTypes = {
  map: propTypes.object, // Inserted by mapping/leaflet.
  script: propTypes.object.isRequired
};
export default TrialPlacementLayer;
